"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBusEventType = void 0;
var EventBusEventType;
(function (EventBusEventType) {
    EventBusEventType["FacilityAccountCreated"] = "FacilityAccountCreated";
    EventBusEventType["NurseAccountCreated"] = "NurseAccountCreated";
    EventBusEventType["HasCompletedApplicationChanged"] = "HasCompletedApplicationChanged";
    EventBusEventType["ShiftCreated"] = "ShiftCreated";
    EventBusEventType["ShiftUpdated"] = "ShiftUpdated";
    EventBusEventType["ShiftCanceled"] = "ShiftCanceled";
    EventBusEventType["ShiftClaimed"] = "ShiftClaimed";
    EventBusEventType["OrientationCreated"] = "OrientationCreated";
    EventBusEventType["OrientationUpdated"] = "OrientationUpdated";
    EventBusEventType["OrientationCanceled"] = "OrientationCanceled";
    EventBusEventType["NursysTransactionCreated"] = "NursysTransactionCreated";
})(EventBusEventType || (exports.EventBusEventType = EventBusEventType = {}));
//# sourceMappingURL=event-bus.js.map